




































import Vue from 'vue';
import Component, { mixins } from "vue-class-component";
import WpBaseComponent from './../components';
import { Initializer, IContext, IdentitySymbols } from 'web-platform-core-ui';

@Component
export default class SibSaleApp extends mixins(Vue, WpBaseComponent) {       
    Loading: boolean = true;
    IsInitializedError: boolean = true;
    IsOffline: boolean = false;
    OnlineStatusChange(isOnline: boolean): void {
        this.IsOffline = !isOnline;
    }

    async mounted() {
        let context = this.GlobalService.Get<IContext>(IdentitySymbols.Context);
        let initResult = await Initializer.InitializeAsync(this.GlobalService);

        if (initResult.Success) {
            this.IsInitializedError = false;
        } else {
            Error(`Initilization error: ${initResult.ErrorMessage}`);
        }

        removeMainLoadingWrapper();
        this.Loading = false;
    }
}
